// import i18n from '@/i18n/index'

export default {
  basicInformation: [{
    prop: 'review_status',
    back: true
  }, {
    prop: 'nickname'
  }, {
    prop: 'email'
  }, {
    prop: 'phone_number'
  }, {
    prop: 'merchant_name'
  }, {
    prop: 'merchant_address'
  }, {
    prop: 'created_at'
  }]
}
